import { Typography } from "@mui/material";
import { useState } from "react";
import Modal from "../ui/Modal";
import { useSnackbar } from "notistack";
import FormItem from "../ui/FormItem";
import { DropzoneArea } from "mui-file-dropzone";

const SubmitAssignment = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const submitQuiz = () => {
    props.close();
  };
  return (
    <Modal
      {...props}
      title="Submit Assignment"
      actionText="Submit"
      loading={loading}
      action={submitQuiz}
    >
      <FormItem label="Upload Submission">
        <DropzoneArea
          filesLimit={1}
          //onChange={uploadInvoice}
          acceptedFiles={["application/pdf"]}
          useChipsForPreview
        />
      </FormItem>
    </Modal>
  );
};

export default SubmitAssignment;
